import { TFunction } from 'i18next'
import { z } from 'zod'

import { BookingCategory } from '@/api/booking-types'

export const BOOKING_NAME_MAX_LENGTH = 99

export const makeGroupFormSchema = (t: TFunction<['organisation', 'common']>) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, t('common:validation.required'))
      .max(
        BOOKING_NAME_MAX_LENGTH,
        t('organisation:bookingTypes.validation.maxLength', { max: BOOKING_NAME_MAX_LENGTH }),
      ),
  })

export type GroupFormData = z.infer<ReturnType<typeof makeGroupFormSchema>>

export const getGroupFormDefaults = (group?: BookingCategory): GroupFormData => ({
  name: group?.name ?? '',
})
